export const summaryTableColumns = (columns) => {
    return columns.map(column => ({
        Header: column === 'rig_data' ? 'Rig Data' : column,
        accessor: column,
    }));
}

export const resultTableColumns = (columns) => {
    return columns.map(column => ({
        Header: column === 'description' ? 'Description' : 'Hours '.concat(`(${column})`),
        accessor: column,
    }));
}